/* ============
 * Product Transformer
 * ============
 *
 * The transformer for the product.
 */

import Transformer from './transformer';
import ware from './productWarehouse';

export default class ProductTransformer extends Transformer {

  static fetch(product) {
    let fieldsData = [];
    try {
      if (product.fields_json !== '') {
        if ((product.fields_json !== undefined || product.fields_json !== 'undefined') && product.fields_json !== null) {
          fieldsData = JSON.parse(product.fields_json);
        }
      }
    } catch (e) {
      fieldsData = [];
    }

    return {
      id: product.id,
      name: product.name,
      number: product.number,
      description: product.description,
      productGroupId: product.product_group_id,
      productTagId: product.product_tag_id,
      productType: product.product_type,
      productTypeGroup: product.product_type_group,
      productTypeId: product.product_type_id,
      productSubtypeId: product.product_subtype_id,
      productPackagingId: product.product_packaging_id,
      productPackagingName: product.product_packaging_name,
      subType: product.sub_type,
      productParentId: product.product_parent_id,
      productParentName: product.product_parent_name,
      containsAlcohol: product.contains_alcohol,
      alcoholPercentage: product.alcohol_percentage,
      price: product.price,
      taxPercentage: product.tax_percentage,
      taxId: product.tax_id,
      icon: product.icon ? { url: product.icon } : undefined,
      duration: product.duration,
      breaktime: product.breaktime,
      appointable: product.appointable,
      productDepositId: product.product_deposit_id,
      depositSystemId: product.deposit_system_id,
      productDepositCheckbox: product.product_deposit_id,
      qty: product.qty,
      externalId: product.external_id,
      warehouses:
        product.warehouses !== undefined
          ? ware.fetchCollection(product.warehouses)
          : [],
      childProducts: product.child_products,
      fieldsJSON: fieldsData,
      excisable: product.excisable,
      paidExcise: product.paid_excise ? 1 : 0,
      inventoryExclude: product.inventory_exclude,
      purchasePrice: product.purchase_price,
      costPrice: product.cost_price,
      errorUpdate: product.error_update,
      ddpVmp: product.ddpVmp,
      retailPriceVmp: product.retailPriceVmp,
      salePriceHoreca: product.salePriceHoreca,
      salesPriceAsko: product.salesPriceAsko,
      salesPriceVinhuset: product.salesPriceVinhuset,
      salesPriceWholesale: product.salesPriceWholesale,
      salesPriceGrocery: product.salesPriceGrocery,
      salesPriceBusiness: product.salesPriceBusiness,
      salesPriceSpecialtyStore: product.salesPriceSpecialtyStore,
      coop: product.coop,
      rema1000: product.rema1000,
      marketplace: product.marketplace,
      epd: product.epd,
      sku: product.sku,
      gtin: product.gtin,
      gtinMultipack: product.gtin_multipack,
      sa: product.sa,
      nobb: product.nobb,
      vmp: product.vmp,
      note: product.note,
      isActive: product.is_active,
      exciseAlcoholGroup: product.excise_alcohol_group,
      exciseBasicGroup: product.excise_basic_group,
      excisePackagingGroup: product.excise_packaging_group,
      exciseAlcoholGroupName: product.excise_alcohol_group_name,
      exciseBasicGroupName: product.excise_basic_group_name,
      excisePackagingGroupName: product.excise_packaging_group_name,
      packaging_group: product.packaging_group,
      initial: product.initial,
      initialValueSku: product.initial_value_sku,
      custom_sku: product.custom_sku,
      update_sku: product.update_sku,
      orderProductNote: product.order_product_note,
      country: product.country,
      region: product.region,
      subRegion: product.subRegion,
      supplier_id: product.supplier_id,
      supplier_name: product.supplier_name,
      vintage: product.vintage,
      producer: product.producer_id,
      bottleVolume: product.bottle_volume,
      packagingMaterial: product.packaging_material,
      packagingMaterialId: product.packaging_material_id,
      packagingName: product.packaging_name,
      packagingQuantity: product.packaging_quantity,
      corkType: product.cork_type,
      lastChanged: product.last_changed,
      marketplaceHasPending: product.marketplace_has_pending,
      marketplaceStatus: product.marketplace_status,
      marketplaceEnabled: product.marketplace_enabled,
      chartOfAccounts: product.chart_of_accounts,
      weightMultipack: product.weightMultipack,
      sugar: product.sugar,
      acid: product.acid,
      fullness: product.fullness,
      freshness: product.freshness,
      bitterness: product.bitterness,
      tannins: product.tannins,
      colour: product.colour,
      odour: product.odour,
      taste: product.taste,
      storagePorential: product.storagePorential,
      organic: product.organic,
      biodynamic: product.biodynamic,
      locallyProduced: product.locallyProduced,
      environmentallySmart: product.environmentallySmart,
      freeOrLowOnGluten: product.freeOrLowOnGluten,
      kosher: product.kosher,
      storagePotential: product.storagePotential,
      ingredients: product.ingredients,
      recommendations: product.recommendations,
      prices: product.prices,
      selectedPrice: product.selected_price,
      manualProcessOrder: product.manual_process_order,
      productBundleGroup: product.product_bundle_group,
      unProductCodeId: product.un_product_code_id,
      minimumOrderQuantity: product.minimum_order_quantity,
      orderableUnitId: product.orderable_unit_id,
      syncToWoo: product.sync_to_woo,
      sellInCase: product.sell_in_case,
      minQty: product.min_qty,
      groupOf: product.group_of,
      onlineStorePrice: product.onlineStorePrice,
      isSharedWarehouse: product.is_shared_warehouse,
    };
  }

  static send(product) {
    return {
      id: product.id,
      name: product.name,
      description: product.description ? product.description : '',
      product_group_id: product.productGroupId
        ? product.productGroupId.toString()
        : '',
      product_tag_id: product.productTagId
        ? product.productTagId.toString()
        : '',
      product_type_id: product.productTypeId,
      product_subtype_id: product.productSubtypeId,
      product_packaging_id: product.productPackagingId
        ? product.productPackagingId
        : '',
      product_parent_id: product.productParentId,
      contains_alcohol: product.containsAlcohol,
      alcohol_percentage: product.alcoholPercentage,
      bottle_volume: product.bottleVolume,
      price: product.price,
      purchase_price: product.purchasePrice,
      cost_price: product.costPrice,
      excisable: product.excisable ? 1 : 0,
      paid_excise: product.paidExcise ? 1 : 0,
      inventory_exclude: product.inventoryExclude,
      tax_id: product.taxId,
      icon: product.icon && product.icon.file ? product.icon.file : '',
      duration: product.duration,
      breaktime: product.breaktime,
      appointable: product.appointable !== '' ? +product.appointable : '',
      product_deposit_id: product.productDepositId,
      deposit_system_id: product.depositSystemId,
      country: product.country,
      deposit: product.deposit,
      product_deposit_checkbox: product.productDepositCheckbox,
      external_id: product.externalId,
      fields_json: product.alcoholPercentage
        ? JSON.stringify(
            Object.assign({}, product, {
              alcohol_percentage: product.alcoholPercentage,
              alcoholPercentage: undefined,
            })
          )
        : JSON.stringify(product),
      source_product_id: product.sourceProductId,
      merge_product_id: product.mergeProductId,
      ddpVmp: product.ddpVmp,
      retailPriceVmp: product.retailPriceVmp,
      salePriceHoreca: product.salePriceHoreca,
      salesPriceAsko: product.salesPriceAsko,
      salesPriceVinhuset: product.salesPriceVinhuset,
      salesPriceWholesale: product.salesPriceWholesale,
      salesPriceGrocery: product.salesPriceGrocery,
      salesPriceBusiness: product.salesPriceBusiness,
      salesPriceSpecialtyStore: product.salesPriceSpecialtyStore,
      coop: product.coop,
      rema1000: product.rema1000,
      marketplace: product.marketplace,
      price_fields: product.price_fields,
      epd: product.epd,
      gtin: product.gtin,
      gtin_multipack: product.gtinMultipack,
      sa: product.sa,
      nobb: product.nobb,
      vmp: product.vmp,
      packaging: product.packaging,
      weightUnit: product.weightUnit,
      weightMultipack: product.weightMultipack,
      numberUnitsMultiPackaging: product.numberUnitsMultiPackaging,
      numberUnitsPallet: product.numberUnitsPallet,
      availableVinhuset: product.availableVinhuset,
      availableAsko: product.availableAsko,
      note: product.note ? product.note : '',
      is_active: product.isActive,
      manual_process_order: product.manualProcessOrder,
      excise_alcohol_group: product.exciseAlcoholGroup,
      excise_basic_group: product.exciseBasicGroup,
      excise_packaging_group: product.excisePackagingGroup,
      packaging_group: product.packagingGroup,
      custom_sku: product.custom_sku,
      update_sku: product.update_sku,
      marketplace_enabled: product.marketplaceEnabled ? 1 : 0,
      income_account_id: product.chartOfAccounts,
      producer_id: product.producer,
      sugar: product.sugar,
      acid: product.acid,
      fullness: product.fullness,
      freshness: product.freshness,
      bitterness: product.bitterness,
      tannins: product.tannins,
      colour: product.colour,
      odour: product.odour,
      taste: product.taste,
      storagePorential: product.storagePorential,
      ingredients: product.ingredients,
      organic: product.organic,
      biodynamic: product.biodynamic,
      locallyProduced: product.locallyProduced,
      environmentallySmart: product.environmentallySmart,
      freeOrLowOnGluten: product.freeOrLowOnGluten,
      kosher: product.kosher,
      recommendations: product.recommendations,
      un_product_code_id: (typeof product.unProductCodeId === 'object') ? product.unProductCodeId.id : product.unProductCodeId,
      minimum_order_quantity: product.minimumOrderQuantity,
      orderable_unit_id: product.orderableUnitId,
      sync_to_woo: product.syncToWoo,
      sell_in_case: product.sellInCase,
      min_qty: product.minQty,
      group_of: product.groupOf,
      online_store_price: product.onlineStorePrice,
    };
  }

  static sendMerge(product) {
    return {
      source_product_id: product.sourceProductId,
      destination_product_id: product.destinationProductId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/product.js